import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Account } from '../models/accountmodel';
import { Password } from '../models/passwordmodel';
import { AccountUpdate } from '../models/accountupdatemodel';
import { Acct } from '../models/acctmodel';
import { Commission } from '../models/commissionmodel';
import { Topup } from '../models/topupmodel';
import { AcctResponse } from '../models/accountresponse';
import { Observable } from 'rxjs/Rx';
import { config } from '../config/config';
import { SharedService } from '../services/sharedservices.service';
import { CommissionUpdate } from 'models/commissionupdatemodel';
import * as CryptoJS from 'crypto-js';
//var fs    = require('fs'), nconf = require('nconf');

@Injectable()
export class accountService {

  accountsUrl: string = config.baseUrl + "accounts";

  url: string = config.baseUrl + "account";
  commission_url: string = config.baseUrl + "commission";
  updateurl: string = config.baseUrl + "account";
  topupurl: string = config.baseUrl + "account/topup";
  passwordurl: string = config.baseUrl + "account/password";
  //authconfig: string = config.username + ':' + config.password;

  constructor(private http: Http, private sharedservice: SharedService) { }

  /*createAuthorizationHeader(headers: Headers) {
    let conversionSessionOutput = CryptoJS.AES.decrypt(localStorage.getItem("access_token"), config.key).toString(CryptoJS.enc.Utf8);
    let authconfig = this.sharedservice.session.account_username + ':' + conversionSessionOutput;
    headers.append('Authorization', 'Basic ' +
      btoa(authconfig));
  }*/

  getCommissions(): Observable<Commission[]> {
    let headers = new Headers();
    // this.createAuthorizationHeader(headers);

    return this.http.get(this.commission_url, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  getAccounts(): Observable<Account[]> {
    const headers = new Headers();
    // this.createAuthorizationHeader(headers);

    return this.http.get(this.accountsUrl, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  getAccount(): Observable<Account> {
    const headers = new Headers();

    headers.append('Content-Type', 'application/json');

    const getUrl = this.accountsUrl + "/auth";
    // this.createAuthorizationHeader(headers);

    return this.http.get(getUrl, { headers: headers, withCredentials: true })
      .map(res => res.json())
      .catch(this.handleError);
  }

  postCommission(commission: Commission): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(commission);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.commission_url, data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }

  updateCommission(commissionupdate: CommissionUpdate): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(commissionupdate);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.put(this.commission_url, data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }

  postAccount(acct: Acct): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(acct);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.url, data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }

  changePassword(password: Password): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(password);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.put(this.passwordurl, data, {headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }


  updateAccount(acct: AccountUpdate): Observable<AcctResponse> {
    const headers = new Headers();
    const data = JSON.stringify(acct);
    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.put(this.updateurl, data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }


  topupAccount(topup: Topup): Observable<AcctResponse> {

    const headers = new Headers();
    const data = JSON.stringify(topup);

    // this.createAuthorizationHeader(headers);
    headers.append('Content-Type', 'application/json');

    return this.http.post(this.topupurl, data, {
      headers: headers,
      withCredentials: true
    })
      .map(res => res.json())
      .catch(this.handleError);
  }

  private handleError(error: Response | any) {
    // In a real world app, we might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /payu/microservice/multichannelportal/src/services/account.service.ts